(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-shipping-progress')) {
    customElements.define(
      'cart-shipping-progress',
      class CartShippingProgress extends HTMLElement {
        connectedCallback() {
          this.localize();
          this.animateFill();
        }

        // The Section Rendering API morphs this element in place after a cart change.
        updatedCallback() {
          this.localize();
          this.animateFill();
        }

        animateFill() {
          const target = Math.min(100, Math.max(0, Number(this.dataset.progress) || 0));
          const previous = window.laydownShippingProgress;
          const hasPrevious = Number.isFinite(previous);

          this.style.setProperty('--shipping-progress', `${hasPrevious ? previous : 0}%`);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.style.setProperty('--shipping-progress', `${target}%`);
            });
          });

          window.laydownShippingProgress = target;
        }

        /**
         * Fallback for a currency missing from the Liquid table: the shop-currency threshold is converted
         * with the rate Shopify exposes on the storefront, since the cart total is already local.
         */
        localize() {
          if (!this.hasAttribute('data-needs-conversion')) return;

          const currency = this.dataset.currency;
          const shopifyCurrency = window.Shopify && window.Shopify.currency;
          const rate = shopifyCurrency && shopifyCurrency.active === currency ? Number(shopifyCurrency.rate) : NaN;

          if (Number.isFinite(rate) && rate > 0) {
            const threshold = Math.round(Number(this.dataset.threshold) * rate);
            const total = Number(this.dataset.cartTotal) || 0;
            const remaining = Math.max(0, threshold - total);
            const unlocked = remaining === 0;
            const progress = threshold > 0 ? Math.min(100, (total * 100) / threshold) : 100;

            this.dataset.progress = String(progress);
            this.dataset.unlocked = String(unlocked);
            this.classList.toggle('cart-shipping-progress--unlocked', unlocked);

            const message = this.querySelector('[data-shipping-message]');
            const track = this.querySelector('[data-shipping-track]');
            const html = unlocked
              ? this.dataset.messageUnlocked
              : this.dataset.messageLocked.replace('[amount]', this.formatAmount(Math.ceil(remaining / 100), currency));

            if (message) message.innerHTML = html;
            if (track) {
              track.setAttribute('aria-valuenow', String(Math.round(progress)));
              track.setAttribute('aria-label', message ? message.textContent.trim() : '');
            }
          }

          this.setAttribute('data-ready', '');
        }

        formatAmount(units, currency) {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(units);
          } catch (error) {
            return `${units} ${currency}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["laydown-banner-glass"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.hero-wrapper, .section-stone-island-hero';
    let controlledHosts = new Set();
    let controlledUnderlays = new Set();
    const expandedUnderlays = new Map();
    let underlayResizeObserver;
    const visible = (element) => element.getBoundingClientRect().height > 0
      && getComputedStyle(element).display !== 'none';
    const createEdge = (featured = false) => {
      const edge = document.createElement('span');
      edge.className = `ld-banner-glass${featured ? ' ld-banner-glass--featured' : ''}`;
      edge.setAttribute('aria-hidden', 'true');
      ['soft', 'medium', 'diffuse'].forEach(level => {
        const layer = document.createElement('span');
        layer.className = `ld-banner-glass__layer ld-banner-glass__layer--${level}`;
        edge.append(layer);
      });
      return edge;
    };
    const setStyle = (element, name, value) => {
      if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
    };
    const refresh = () => {
      const main = document.getElementById('MainContent');
      if (!main) return;
      const sections = [...main.children].filter(el => el.classList.contains('shopify-section') && visible(el));
      const measurements = new Map(sections.map(el => [el, { rect: el.getBoundingClientRect(), position: getComputedStyle(el).position }]));
      const underlays = new Set();
      const underlayUpdates = [];
      sections.forEach((host, index) => {
        const recommendation = host.querySelector(':scope > product-recommendations[data-ld-overlap="true"]');
        const previous = sections[index - 1];
        if (!recommendation || !previous) return;
        const height = measurements.get(previous).rect.height;
        const defaultTop = Math.min(0, window.innerHeight - height);
        const openDetails = previous.querySelector('details[open]');
        let stickyTop = defaultTop;
        if (openDetails) {
          const expanded = expandedUnderlays.get(previous);
          stickyTop = Math.min(defaultTop, expanded?.details === openDetails
            ? expanded.top + expanded.height - height
            : measurements.get(host).rect.top - height);
          expandedUnderlays.set(previous, { details: openDetails, height, top: stickyTop });
        } else expandedUnderlays.delete(previous);
        underlays.add(previous);
        underlayUpdates.push({ previous, stickyTop });
      });
      const hosts = new Set();
      const nextControlledHosts = new Set();
      const hostUpdates = [];
      sections.forEach((hero, index) => {
        const host = sections[index + 1];
        const recommendation = host?.querySelector(':scope > product-recommendations[data-ld-overlap="true"]');
        const recommendationOverlap = recommendation && underlays.has(hero);
        if (!host || (!recommendationOverlap && (!hero.matches(selector) || measurements.get(hero).position !== 'sticky'))) return;
        const configured = parseFloat(getComputedStyle(recommendationOverlap ? host : hero).getPropertyValue(
          recommendationOverlap ? '--ld-recommendations-edge-strength' : '--ld-banner-edge-strength'
        ));
        const strength = Number.isFinite(configured) ? Math.min(1, Math.max(0, configured)) : .86;
        const featured = Boolean(host.querySelector('[data-ld-featured-card-fade]'));
        const firstItem = featured ? host.querySelector('.resource-list--grid > .resource-list__item:first-child') : null;
        const surface = host.querySelector(':scope > .section-background, :scope > .section, :scope > product-recommendations > .section-background, [class*="color-scheme-"]') || host;
        const color = featured ? '' : getComputedStyle(surface).getPropertyValue('--color-background').trim();
        nextControlledHosts.add(host);
        if (!featured) hosts.add(host);
        hostUpdates.push({ host, strength, featured, firstItem, color, recommendationOverlap });
      });
      underlayUpdates.forEach(({ previous, stickyTop }) => {
        previous.classList.add('ld-recommendations-underlay');
        setStyle(previous, '--ld-recommendations-sticky-top', `${stickyTop}px`);
        if (!controlledUnderlays.has(previous)) underlayResizeObserver?.observe(previous);
      });
      controlledUnderlays.forEach(section => {
        if (!underlays.has(section)) {
          section.classList.remove('ld-recommendations-underlay');
          section.style.removeProperty('--ld-recommendations-sticky-top');
          underlayResizeObserver?.unobserve(section);
          expandedUnderlays.delete(section);
        }
      });
      controlledUnderlays = underlays;
      hostUpdates.forEach(({ host, strength, featured, firstItem, color, recommendationOverlap }) => {
        setStyle(host, '--ld-edge-strength', String(strength));
        if (featured) {
          if (firstItem && !firstItem.querySelector(':scope > .ld-banner-glass--featured')) firstItem.prepend(createEdge(true));
          return;
        }
        host.classList.add('ld-banner-glass-host');
        host.classList.toggle('ld-recommendations-glass-host', Boolean(recommendationOverlap));
        if (color) setStyle(host, '--ld-banner-glass-color', color);
        if (!host.querySelector(':scope > .ld-banner-glass')) host.prepend(createEdge());
      });
      controlledHosts.forEach(host => {
        if (!nextControlledHosts.has(host)) host.style.removeProperty('--ld-edge-strength');
      });
      controlledHosts = nextControlledHosts;
      main.querySelectorAll(':scope > .ld-banner-glass-host').forEach(host => {
        if (hosts.has(host)) return;
        host.querySelector(':scope > .ld-banner-glass')?.remove();
        host.classList.remove('ld-banner-glass-host', 'ld-recommendations-glass-host');
        host.style.removeProperty('--ld-banner-glass-color');
      });
    };
    let frame;
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(refresh); };
    if (typeof ResizeObserver !== 'undefined') underlayResizeObserver = new ResizeObserver(schedule);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
    else schedule();
    window.addEventListener('load', schedule, { once: true });
    window.addEventListener('resize', () => { expandedUnderlays.clear(); schedule(); }, { passive: true });
    document.addEventListener('toggle', event => {
      if (event.target instanceof HTMLDetailsElement && event.target.closest('.ld-recommendations-underlay')) schedule();
    }, true);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => document.addEventListener(event, schedule));
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (records.some(record => record.target === main || record.target.nodeName === 'STYLE' ||
        record.target.parentElement?.nodeName === 'STYLE' || record.target.matches?.(selector) ||
        record.target.matches?.('product-recommendations'))) schedule();
    }).observe(main, { childList: true, subtree: true, characterData: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["laydown-card-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-ld-card-preview]';
  let active = null;
  let pending = null;
  let touch = null;
  let suppressed = null;
  let ignoreMouseUntil = 0;

  const reset = () => {
    pending = null;
    active?.removeAttribute('data-ld-card-preview-active');
    active = null;
  };

  const galleryAt = (event) => {
    if (!(event.target instanceof Element)) return null;
    const card = event.target.closest('product-card, .resource-card, .cart-upsell');
    const gallery = event.target.closest(selector) || card?.querySelector(selector);
    const image = gallery?.querySelector('.ld-card-preview-image');
    if (!image || (image.complete && !image.naturalWidth)) return null;
    const control = event.target.closest('button, input, select, textarea, label, summary, [role="button"]');
    if (control && control !== gallery) return null;
    const box = gallery.getBoundingClientRect();
    return event.clientX >= box.left && event.clientX <= box.right &&
      event.clientY >= box.top && event.clientY <= box.bottom ? gallery : null;
  };

  const show = (gallery) => {
    if (gallery === active || gallery === pending) return;
    reset();
    pending = gallery;
    const image = gallery.querySelector('.ld-card-preview-image');
    const reveal = () => {
      if (pending !== gallery || !gallery.isConnected || !image.naturalWidth) return;
      gallery.setAttribute('data-ld-card-preview-active', '');
      active = gallery;
      pending = null;
    };
    if (image.complete && image.naturalWidth) {
      reveal();
    } else {
      image.loading = 'eager';
      image.decode().then(reveal).catch(() => {
        if (pending === gallery) {
          pending = null;
        }
      });
    }
  };

  const isMouse = (event) => event.pointerType === 'mouse' && !touch &&
    !event.sourceCapabilities?.firesTouchEvents && performance.now() >= ignoreMouseUntil;

  document.addEventListener('pointerover', (event) => {
    if (!isMouse(event)) return;
    const gallery = galleryAt(event);
    if (gallery) show(gallery);
    else reset();
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    if (!isMouse(event)) return;
    const gallery = active || pending;
    if (!gallery) return;
    if (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget)) return;
    reset();
  }, { passive: true });

  const beginTouch = (event, id, nativeId = null) => {
    suppressed = null;
    ignoreMouseUntil = performance.now() + 1000;
    touch = {
      target: event.target, gallery: galleryAt(event), id, nativeId,
      x: event.clientX, y: event.clientY,
      clientX: event.clientX, clientY: event.clientY,
      started: performance.now(), moved: false, cancelled: false
    };
    if (touch.gallery) show(touch.gallery);
    else reset();
  };

  const updateTouch = (clientX, clientY) => {
    if (!touch) return;
    touch.clientX = clientX;
    touch.clientY = clientY;
    if (Math.hypot(clientX - touch.x, clientY - touch.y) > 10) touch.moved = true;
  };

  const finishTouch = (cancelled = false) => {
    if (!touch) return;
    const gesture = touch;
    touch = null;
    ignoreMouseUntil = performance.now() + 1000;
    const gallery = gesture.gallery;
    const isTap = !cancelled && !gesture.cancelled && !gesture.moved;
    const blockClick = !isTap || performance.now() - gesture.started >= 300;
    // Release and cancellation always restore the base media, including after a swipe.
    // reset() also cancels a pending image decode so it cannot reopen the preview later.
    reset();
    if (blockClick) {
      suppressed = { target: gesture.target, gallery, until: performance.now() + 800 };
    }
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    if (!event.isPrimary) {
      if (touch) touch.cancelled = true;
      return;
    }
    beginTouch(event, event.pointerId);
  }, { capture: true, passive: true });

  document.addEventListener('pointermove', (event) => {
    if (!touch || event.pointerId !== touch.id || touch.nativeId !== null) return;
    updateTouch(event.clientX, event.clientY);
  }, { capture: true, passive: true });

  const release = (event) => {
    if (!touch || event.pointerId !== touch.id || touch.nativeId !== null) return;
    updateTouch(event.clientX, event.clientY);
    finishTouch(event.type === 'pointercancel');
  };
  document.addEventListener('pointerup', release, { capture: true, passive: true });
  document.addEventListener('pointercancel', release, { capture: true, passive: true });

  document.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 1) {
      if (touch) touch.cancelled = true;
      return;
    }
    const contact = event.changedTouches[0];
    if (!contact) return;
    if (!touch) beginTouch(contact, null, contact.identifier);
    else touch.nativeId = contact.identifier;
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!touch || touch.nativeId === null) return;
    if (event.touches.length !== 1) touch.cancelled = true;
    const contact = Array.from(event.touches).find((item) => item.identifier === touch.nativeId);
    if (contact) updateTouch(contact.clientX, contact.clientY);
    else finishTouch(true);
  }, { capture: true, passive: true });

  const releaseContact = (event) => {
    if (!touch || touch.nativeId === null) return;
    const contact = Array.from(event.changedTouches).find((item) => item.identifier === touch.nativeId);
    if (!contact) return;
    updateTouch(contact.clientX, contact.clientY);
    finishTouch(event.type === 'touchcancel');
  };
  document.addEventListener('touchend', releaseContact, { capture: true, passive: true });
  document.addEventListener('touchcancel', releaseContact, { capture: true, passive: true });

  window.addEventListener('click', (event) => {
    if (!suppressed || performance.now() > suppressed.until) return;
    if (event.detail === 0 && event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    const target = event.target;
    const sameTarget = target instanceof Node && suppressed.target instanceof Node &&
      (target === suppressed.target || target.contains(suppressed.target) || suppressed.target.contains(target));
    if (!sameTarget && (!suppressed.gallery || galleryAt(event) !== suppressed.gallery)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    suppressed = null;
  }, true);

  document.addEventListener('contextmenu', (event) => {
    if (!touch?.gallery || galleryAt(event) !== touch.gallery) return;
    event.preventDefault();
  }, true);

  document.addEventListener('scroll', () => {
    if (touch) touch.moved = true;
  }, { capture: true, passive: true });

  const clear = () => { touch = null; suppressed = null; reset(); };
  window.addEventListener('blur', clear);
  window.addEventListener('pagehide', clear);
  window.addEventListener('pageshow', clear);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clear();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') clear();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["laydown-card-video"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__ldCardVideos) return;
  window.__ldCardVideos = true;

  const selector = 'video[data-ld-card-video]';
  const states = new Map();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let suspended = document.hidden;
  // One phase for every card, including cards loaded later by search or filters.
  const cycleDuration = 262 / 60;
  let clockStartedAt = null;
  let clockTimer = null;

  const wantsPlayback = (state) => state.visible && !state.covered && !state.failed &&
    !reducedMotion.matches && !suspended && !document.hidden && state.video.isConnected &&
    state.slide?.getAttribute('aria-hidden') !== 'true';

  const alignToClock = (state) => {
    const video = state.video;
    if (video.hasAttribute('data-ld-menu-video')) return;
    const now = performance.now();
    // A seek before the first decoded frames can abort Safari's pending play().
    // Let the decoder run, including after every seek, before moving its timeline.
    if (!wantsPlayback(state) || video.paused || !state.decoded ||
        now - state.playingAt < 300 || video.readyState < 3 || video.seeking ||
        !Number.isFinite(video.duration) || video.duration <= 0) return;
    if (clockStartedAt === null) clockStartedAt = now - video.currentTime * 1000;
    const start = Math.min(Number(video.dataset.ldCardVideoSyncStart) || 0, video.duration / 2);
    const span = video.duration - start;
    const phase = ((now - clockStartedAt) / 1000 % cycleDuration) / cycleDuration;
    const target = start + phase * span;
    const rate = Math.max(0.25, Math.min(4, span / cycleDuration));
    let drift = (video.currentTime - target) / span;
    drift -= Math.round(drift);
    const driftSeconds = drift * cycleDuration;
    // Small differences converge through playback speed, without decoder seeks.
    const correction = Math.abs(driftSeconds) > 0.03 ? Math.max(-0.05, Math.min(0.05, -driftSeconds * 0.3)) : 0;
    const adjustedRate = rate * (1 + correction);
    if (Math.abs(video.playbackRate - adjustedRate) > 0.001) video.playbackRate = adjustedRate;
    if (Math.abs(driftSeconds) > 0.18 && now - state.lastSeekAt > 1800) {
      state.lastSeekAt = now;
      try { video.currentTime = Math.min(target, video.duration - 0.001); } catch (_) { /* Keep native playback. */ }
    }
  };

  const updateClockTimer = () => {
    const active = [...states.values()].some((state) => !state.video.hasAttribute('data-ld-menu-video') && wantsPlayback(state) && !state.video.paused);
    if (active && clockTimer === null) {
      clockTimer = setInterval(() => {
        for (const state of states.values()) alignToClock(state);
        updateClockTimer();
      }, 250);
    } else if (!active && clockTimer !== null) {
      clearInterval(clockTimer);
      clockTimer = null;
    }
  };

  const prepare = (state) => {
    if (state.loaded && !state.video.getAttribute('src')) state.loaded = false;
    if (state.loaded || state.failed || reducedMotion.matches) return;
    let sources;
    try { sources = JSON.parse(state.video.dataset.ldCardVideoSources || '[]'); }
    catch (_) { return; }
    if (!sources.length) return;
    const targetWidth = Math.min(960, Math.ceil(state.video.getBoundingClientRect().width *
      Math.min(window.devicePixelRatio || 1, 2)));
    const source = sources.find((item) => item.width >= targetWidth) || sources[sources.length - 1];
    state.video.muted = true;
    state.video.defaultMuted = true;
    state.video.playsInline = true;
    state.video.preload = 'auto';
    // Assign once. Joining the clock never reloads the media source.
    state.video.src = source.url;
    state.loaded = true;
  };

  const sync = (state) => {
    if (!wantsPlayback(state)) {
      state.video.pause();
      updateClockTimer();
      return;
    }
    prepare(state);
    if (!state.loaded) return;
    if (state.playingPromise) {
      state.pendingSync = true;
      return;
    }
    if (!state.video.paused) {
      alignToClock(state);
      updateClockTimer();
      return;
    }
    // Start before loadeddata: mobile browsers may defer buffering until play().
    const promise = state.video.play();
    if (!promise?.then) return;
    state.playingPromise = promise;
    promise.then(() => {
      if (!wantsPlayback(state)) state.video.pause();
      else alignToClock(state);
      updateClockTimer();
    }).catch(() => {
      // Autoplay restrictions leave the poster visible; a later gesture can retry.
    }).finally(() => {
      state.playingPromise = null;
      if (state.pendingSync) {
        state.pendingSync = false;
        sync(state);
      }
    });
  };

  const previewChanged = (state) => {
    clearTimeout(state.coverTimer);
    if (state.gallery.hasAttribute('data-ld-card-preview-active')) {
      // Keep the frame moving during the existing 350 ms photo fade.
      state.coverTimer = setTimeout(() => {
        state.covered = true;
        sync(state);
      }, reducedMotion.matches ? 0 : 350);
    } else {
      state.covered = false;
      sync(state);
    }
  };

  const prepareObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const state = states.get(entry.target);
      if (!state || !entry.isIntersecting) continue;
      prepare(state);
      prepareObserver.unobserve(entry.target);
    }
  }, { rootMargin: '450px 0px' }) : null;

  const playbackObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const state = states.get(entry.target);
      if (!state) continue;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
      sync(state);
    }
  }, { threshold: [0, 0.15] }) : null;

  const register = (video) => {
    if (states.has(video)) return;
    const gallery = video.closest('[data-ld-card-video-gallery]');
    if (!gallery) return;
    const state = {
      video, gallery, slide: video.closest('slideshow-slide'),
      visible: !playbackObserver, loaded: false, failed: false,
      covered: gallery.hasAttribute('data-ld-card-preview-active'),
      coverTimer: null, playingPromise: null, pendingSync: false,
      decoded: false, buffering: false, playingAt: 0, playingTime: 0, lastSeekAt: -Infinity,
      frameCallback: null, poster: video.getAttribute('poster'),
      sourceList: video.dataset.ldCardVideoSources
    };
    const showFallback = () => {
      state.decoded = false;
      state.playingTime = video.currentTime;
      gallery.removeAttribute('data-ld-card-video-ready');
      if (state.poster && !video.hasAttribute('poster')) video.setAttribute('poster', state.poster);
    };
    state.showFallback = showFallback;
    const revealDecodedFrame = () => {
      if (state.buffering || !state.decoded || video.readyState < 2 || !video.videoWidth || video.paused || video.seeking) return;
      video.removeAttribute('poster');
      gallery.setAttribute('data-ld-card-video-ready', '');
    };
    states.set(video, state);
    const cover = video.parentElement.querySelector('.ld-card-video-cover');
    cover?.addEventListener('error', () => { cover.style.visibility = 'hidden'; });
    video.addEventListener('timeupdate', () => {
      // Some Safari sessions expose the frame API without delivering its callback.
      // Actual timeline advancement is a second signal, even when that API exists.
      if (!state.buffering && !video.paused && !video.seeking && video.readyState >= 2 && video.currentTime > state.playingTime + 0.05) state.decoded = true;
      revealDecodedFrame();
      alignToClock(state);
    });
    video.addEventListener('pause', () => {
      showFallback();
      updateClockTimer();
      // WebKit may suspend its decoder at a loop/seek boundary. A visible card
      // still requests playback; covered, hidden and reduced-motion cards do not.
      if (wantsPlayback(state)) requestAnimationFrame(() => sync(state));
    });
    video.addEventListener('playing', () => {
      state.buffering = false;
      state.playingAt = performance.now();
      state.playingTime = video.currentTime;
      state.decoded = false;
      if (state.frameCallback !== null) video.cancelVideoFrameCallback?.(state.frameCallback);
      if (video.requestVideoFrameCallback) {
        state.frameCallback = video.requestVideoFrameCallback(() => {
          state.frameCallback = null;
          state.decoded = !video.paused;
          revealDecodedFrame();
        });
      }
      updateClockTimer();
      if (!wantsPlayback(state)) video.pause();
    });
    video.addEventListener('waiting', () => {
      // HAVE_CURRENT_DATA (2) is not enough to continue playing.
      state.buffering = true;
      showFallback();
    });
    video.addEventListener('stalled', () => {
      if (video.readyState < 3) {
        state.buffering = true;
        showFallback();
      }
    });
    video.addEventListener('canplay', () => {
      if (wantsPlayback(state) && video.paused) sync(state);
    });
    video.addEventListener('emptied', showFallback);
    video.addEventListener('error', () => {
      state.failed = true;
      gallery.removeAttribute('data-ld-card-video-ready');
      gallery.setAttribute('data-ld-card-video-error', '');
      video.pause();
    });
    prepareObserver?.observe(video);
    playbackObserver?.observe(video);
    if (!playbackObserver) sync(state);
  };

  const scan = (root) => {
    if (root instanceof Element && root.matches(selector)) register(root);
    root.querySelectorAll?.(selector).forEach(register);
  };

  const refresh = () => {
    for (const state of states.values()) sync(state);
  };

  const clearDepartureFrames = () => {
    document.querySelectorAll('.ld-card-departure-frame').forEach((canvas) => canvas.remove());
  };

  // Preserve the actual decoded frame independently of the mobile video layer.
  // No navigation delay, reload, seek, or exported cross-origin canvas is needed.
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('button, input, select, textarea, label, summary, [role="button"]')) return;
    const card = event.target.closest('product-card, product-card-link, .resource-card');
    const gallery = event.target.closest('[data-ld-card-video-gallery]') || card?.querySelector('[data-ld-card-video-gallery]');
    const video = gallery?.querySelector(selector);
    if (!video || video.readyState < 2 || !video.videoWidth ||
        video.closest('slideshow-slide')?.getAttribute('aria-hidden') === 'true' ||
        gallery.hasAttribute('data-ld-card-preview-active')) return;
    const link = event.target.closest('a') || card?.querySelector('a[href]');
    if (!link?.href || new URL(link.href, location.href).origin !== location.origin) return;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');
    if (!context) return;
    try { context.drawImage(video, 0, 0); } catch (_) { return; }
    clearDepartureFrames();
    canvas.className = 'ld-card-departure-frame';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.objectFit = getComputedStyle(video).objectFit;
    video.parentElement.appendChild(canvas);
    setTimeout(() => { if (event.defaultPrevented) canvas.remove(); }, 0);
  }, true);

  const start = () => {
    scan(document);
    new MutationObserver((records) => {
      let removed = false;
      for (const record of records) {
        if (record.type === 'attributes') {
          if (record.target.matches(selector)) {
            const state = states.get(record.target);
            if (!state) continue;
            const sourceChanged = state.sourceList !== state.video.dataset.ldCardVideoSources;
            if (sourceChanged || (state.loaded && !state.video.getAttribute('src'))) {
              state.sourceList = state.video.dataset.ldCardVideoSources;
              state.loaded = false;
              state.failed = false;
              state.gallery.removeAttribute('data-ld-card-video-error');
              state.showFallback();
              sync(state);
            }
          } else if (record.attributeName === 'aria-hidden') {
            record.target.querySelectorAll(selector).forEach((video) => {
              const state = states.get(video);
              if (state) sync(state);
            });
          } else {
            const state = states.get(record.target.querySelector(selector));
            if (state) previewChanged(state);
          }
        } else {
          record.addedNodes.forEach(scan);
          if (record.removedNodes.length) removed = true;
        }
      }
      if (removed) {
        for (const [video, state] of states) {
          if (video.isConnected) continue;
          clearTimeout(state.coverTimer);
          if (state.frameCallback !== null) video.cancelVideoFrameCallback?.(state.frameCallback);
          video.pause();
          prepareObserver?.unobserve(video);
          playbackObserver?.unobserve(video);
          states.delete(video);
        }
        updateClockTimer();
      }
    }).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['data-ld-card-preview-active', 'aria-hidden', 'src', 'data-ld-card-video-sources']
    });
  };

  window.addEventListener('online', () => {
    for (const state of states.values()) {
      if (!state.failed) continue;
      state.failed = false;
      state.loaded = false;
      state.gallery.removeAttribute('data-ld-card-video-error');
      state.showFallback();
    }
    refresh();
  });

  document.addEventListener('visibilitychange', () => {
    suspended = document.hidden;
    refresh();
  });
  window.addEventListener('pagehide', () => { suspended = true; refresh(); });
  window.addEventListener('pageshow', () => { clearDepartureFrames(); suspended = document.hidden; refresh(); });
  reducedMotion.addEventListener('change', refresh);
  // Retry only after a real gesture, without consuming the product link's click.
  // Keep play() inside the gesture on iOS when autoplay requires an interaction.
  document.addEventListener('pointerup', refresh, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["laydown-product-lens"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('laydown-product-lens')) return;

    const ZOOM = 2;
    const BEND = 60;
    const FRINGE = 30;
    const FLEX = Object.freeze({ height: 0.72, amount: 0.24, response: 0.27, damping: 0.70, velocityFilter: 0.026, normalization: 1.4 });
    const APPEAR = Object.freeze({ response: 0.40, damping: 0.80, lift: 0.38, startScale: 0.16, closeDuration: 0.18 });
    const springStep = (state, target, dt, response = FLEX.response, damping = FLEX.damping) => {
      const omega = 2 * Math.PI / response;
      const decay = damping * omega;
      const frequency = omega * Math.sqrt(1 - damping ** 2);
      const displacement = state.value - target;
      const sine = Math.sin(frequency * dt);
      const cosine = Math.cos(frequency * dt);
      const envelope = Math.exp(-decay * dt);
      const coefficient = (state.velocity + decay * displacement) / frequency;
      state.value = target + envelope * (displacement * cosine + coefficient * sine);
      state.velocity = envelope * (state.velocity * cosine - (decay * coefficient + frequency * displacement) * sine);
    };
    const VERTEX = 'attribute vec2 pos; varying vec2 uv; void main(){uv=vec2(pos.x*.5+.5,.5-pos.y*.5);gl_Position=vec4(pos,0.,1.);}';
    const FRAGMENT = `
      #ifdef GL_FRAGMENT_PRECISION_HIGH
      precision highp float;
      #else
      precision mediump float;
      #endif
      uniform sampler2D photo;
      uniform vec2 imageSize;
      uniform vec2 imageOffset;
      uniform vec2 center;
      uniform float diameter;
      uniform vec2 shapeScale;
      varying vec2 uv;
      vec4 samplePhoto(vec2 p){
        vec2 t=(p-imageOffset)/imageSize;
        if(t.x<0.||t.x>1.||t.y<0.||t.y>1.) return vec4(0.);
        return texture2D(photo,t);
      }
      void main(){
        vec2 halfSize=diameter*shapeScale*.5;
        vec2 p=(uv-.5)*diameter*shapeScale;
        float radius=min(halfSize.x,halfSize.y);
        vec2 corner=abs(p)-(halfSize-vec2(radius));
        vec2 outside=max(corner,0.);
        float distanceToEdge=length(outside)+min(max(corner.x,corner.y),0.)-radius;
        vec2 normal=sign(p)*outside/max(length(outside),.001);
        float bevel=min(radius,max(22.,radius*.36));
        float edge=pow(1.-clamp(-distanceToEdge/bevel,0.,1.),2.4);
        vec2 offset=normal*edge*bevel*1.1*${(BEND / 100).toFixed(2)};
        vec2 q=center+p/${ZOOM.toFixed(1)}+offset;
        vec4 middle=samplePhoto(q);
        vec4 glass=vec4(samplePhoto(q+offset*${FRINGE / 100}).r,middle.g,samplePhoto(q-offset*${FRINGE / 100}).b,middle.a);
        float rim=1.-smoothstep(.5,2.2,abs(distanceToEdge+1.4));
        float light=rim*(.18+.75*max(dot(normal,normalize(vec2(-1.,-1.))),0.));
        glass.rgb=clamp(glass.rgb+vec3(light*.4),0.,1.);
        gl_FragColor=glass;
      }
    `;

    class LaydownProductLens extends HTMLElement {
      static active = null;

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.toggle = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.gallery = this.closest('media-gallery');
        if (!this.toggle || !this.gallery) return;
        this.hoverQuery = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.containers = [...this.gallery.querySelectorAll('.product-media-container')]
          .filter((container) => !container.closest('zoom-dialog') && container.querySelector('.product-media__image') && !container.querySelector('video, model-viewer, deferred-media, product-model'));
        const options = { signal: this.controller.signal };
        this.motionQuery.addEventListener('change', () => {
          if (!this.open) { this.dispose(); return; }
          this.life = null;
          this.resetMotion();
          this.draw();
        }, options);
        const updateMode = () => {
          this.deactivate(true);
          this.toggleAttribute('data-hover', this.hoverQuery.matches);
          this.syncButton();
        };
        this.hoverQuery.addEventListener('change', updateMode, options);
        this.toggleAttribute('data-hover', this.hoverQuery.matches);
        this.toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.open ? this.deactivate() : this.activate(this.currentContainer());
        }, options);
        this.toggle.addEventListener('mousedown', (event) => event.stopPropagation(), options);
        this.toggle.addEventListener('keydown', (event) => {
          if (!this.open) return;
          const steps = { ArrowLeft: [-16, 0], ArrowRight: [16, 0], ArrowUp: [0, -16], ArrowDown: [0, 16] };
          const step = steps[event.key];
          if (step) {
            event.preventDefault();
            event.stopPropagation();
            this.move(this.x + step[0], this.y + step[1]);
          }
        }, options);
        for (const container of this.containers) {
          const image = container.querySelector('.product-media__image');
          image.addEventListener('pointerenter', (event) => {
            if (this.hoverQuery.matches && event.pointerType !== 'touch') this.activate(container, event);
          }, options);
          image.addEventListener('pointermove', (event) => {
            if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
            if (!this.open) this.activate(container, event);
            else this.follow(event);
          }, options);
          image.addEventListener('pointerleave', () => {
            if (this.hoverQuery.matches && this.container === container) this.deactivate();
          }, options);
          container.addEventListener('pointerdown', (event) => {
            if (this.hoverQuery.matches || !event.isPrimary || event.button !== 0) return;
            this.tap = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false, container };
          }, { ...options, passive: true });
          container.addEventListener('pointermove', (event) => {
            if (this.tap?.id === event.pointerId && Math.hypot(event.clientX - this.tap.x, event.clientY - this.tap.y) > 8) this.tap.moved = true;
          }, { ...options, passive: true });
          container.addEventListener('pointercancel', () => { this.tap = null; }, options);
          container.addEventListener('click', (event) => {
            if (this.hoverQuery.matches || !this.tap || this.tap.moved || this.tap.container !== container) return;
            const tap = this.tap;
            this.tap = null;
            if (event.target.closest('button, a, video, model-viewer')) return;
            event.preventDefault();
            event.stopPropagation();
            if (this.open) this.deactivate();
            else this.activate(container, { clientX: tap.x, clientY: tap.y });
          }, options);
          image.addEventListener('load', () => this.syncButton(), options);
        }
        this.gallery.addEventListener('slideshow:select', (event) => {
          if (event.detail?.index !== undefined && event.detail.index === event.detail.previousIndex) return;
          this.tap = null;
          this.deactivate();
          this.queueButton();
        }, options);
        this.gallery.addEventListener('scroll', (event) => {
          if (!event.target.matches?.('slideshow-slides')) return;
          if (this.tap) this.tap.moved = true;
          this.deactivate();
          this.queueButton();
        }, { ...options, capture: true, passive: true });
        this.gallery.addEventListener('click', (event) => {
          if (event.target.closest('slideshow-controls, slideshow-arrows')) this.deactivate();
        }, { ...options, capture: true });
        this.resizeObserver = new ResizeObserver(() => {
          this.deactivate();
          this.queueButton();
        });
        this.resizeObserver.observe(this.gallery);
        this.syncButton();
      }

      currentContainer() {
        const gallery = this.gallery.getBoundingClientRect();
        return this.containers.find((container) => {
          const rect = container.getBoundingClientRect();
          if (!rect.width || !rect.height || container.getAttribute('aria-hidden') === 'true') return false;
          return rect.left < gallery.right && rect.right > gallery.left;
        });
      }

      queueButton() {
        if (this.buttonFrame) return;
        this.buttonFrame = requestAnimationFrame(() => { this.buttonFrame = 0; this.syncButton(); });
      }

      syncButton() {
        const container = this.currentContainer();
        this.toggle.hidden = !container;
        if (!container) return;
        const host = this.getBoundingClientRect();
        const viewport = this.gallery.querySelector('slideshow-slides');
        const frame = viewport?.getBoundingClientRect();
        const rect = frame?.width ? frame : container.getBoundingClientRect();
        this.style.setProperty('--laydown-lens-button-top', `${rect.bottom - host.top - 46}px`);
      }

      follow(event) {
        const host = this.getBoundingClientRect();
        this.move(event.clientX - host.left, event.clientY - host.top);
      }

      disconnectedCallback() {
        this.deactivate(true);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.buttonFrame);
        this.buttonFrame = 0;
      }

      activate(container = this.currentContainer(), point) {
        if (!container) return;
        if (this.open && this.container === container) { if (point) this.follow(point); return; }
        const image = container.querySelector('.product-media__image');
        if (!image?.complete || !image.naturalWidth) return;
        LaydownProductLens.active?.deactivate(true);
        this.dispose();
        this.container = container;
        this.image = image;
        this.sourceUrl = image.currentSrc || image.src;
        if (!this.measure()) return;
        this.open = true;
        LaydownProductLens.active = this;
        this.activeController = new AbortController();
        const signal = this.activeController.signal;
        this.bubble = document.createElement('div');
        this.bubble.className = 'laydown-product-lens__bubble';
        this.bubble.setAttribute('aria-hidden', 'true');
        this.bubble.dataset.renderer = 'canvas2d';
        this.bubble.style.width = `${this.diameter}px`;
        this.bubble.style.height = `${this.diameter}px`;
        this.plain = document.createElement('canvas');
        this.plain.className = 'laydown-product-lens__plain';
        this.plain.width = this.plain.height = Math.round(this.diameter * this.dpr);
        this.context = this.plain.getContext('2d');
        if (!this.context) { this.deactivate(true); return; }
        this.bubble.append(this.plain);
        this.append(this.bubble);
        this.x = this.bounds.left + this.bounds.width / 2;
        this.y = this.bounds.top + this.bounds.height / 2;
        if (point) {
          const host = this.getBoundingClientRect();
          this.setPosition(point.clientX - host.left, point.clientY - host.top);
        }
        this.resetMotion();
        this.life = this.motionQuery.matches ? null : { kind: 'opening', started: performance.now(), progress: { value: 0, velocity: 0 } };
        this.draw();
        this.bubble.getBoundingClientRect();
        this.toggle.setAttribute('aria-pressed', 'true');
        this.status.textContent = this.toggle.dataset.help;
        this.bubble.addEventListener('pointerdown', (event) => this.startDrag(event), { signal });
        this.bubble.addEventListener('pointermove', (event) => this.drag(event), { signal });
        this.bubble.addEventListener('pointerup', (event) => this.endDrag(event), { signal });
        this.bubble.addEventListener('pointercancel', () => this.deactivate(), { signal });
        this.bubble.addEventListener('lostpointercapture', () => { this.dragging = null; }, { signal });
        this.bubble.addEventListener('mousedown', (event) => event.stopPropagation(), { signal });
        this.bubble.addEventListener('click', (event) => event.stopPropagation(), { signal });
        this.scrollY = window.scrollY;
        window.addEventListener('scroll', () => {
          const next = window.scrollY;
          if (next > this.scrollY + 1) this.deactivate();
          this.scrollY = Math.min(next, this.scrollY);
        }, { passive: true, signal });
        window.addEventListener('resize', () => this.deactivate(), { passive: true, signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.deactivate(true);
        }, { signal });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.deactivate();
        }, { signal });
        image.addEventListener('load', () => this.deactivate(), { signal });
        this.sourceObserver = new MutationObserver(() => {
          if ((image.currentSrc || image.src) !== this.sourceUrl) this.deactivate();
        });
        this.sourceObserver.observe(image, { attributes: true, attributeFilter: ['src', 'srcset', 'sizes'] });
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.open) return;
          this.enhance();
          this.bubble.dataset.visible = '';
          if (this.life) this.queueMotion();
        });
      }

      measure() {
        const host = this.getBoundingClientRect();
        const image = this.image.getBoundingClientRect();
        if (!image.width || !image.height) return false;
        const style = getComputedStyle(this.image);
        const iw = this.image.naturalWidth;
        const ih = this.image.naturalHeight;
        let sx = image.width / iw;
        let sy = image.height / ih;
        if (style.objectFit === 'contain') sx = sy = Math.min(sx, sy);
        else if (style.objectFit === 'cover') sx = sy = Math.max(sx, sy);
        else if (style.objectFit === 'none') sx = sy = 1;
        else if (style.objectFit === 'scale-down') sx = sy = Math.min(1, sx, sy);
        const tokens = style.objectPosition.split(' ');
        const position = (token, free) => {
          if (token?.endsWith('%')) return free * parseFloat(token) / 100;
          if (token?.endsWith('px')) return parseFloat(token);
          return token === 'left' || token === 'top' ? 0 : token === 'right' || token === 'bottom' ? free : free / 2;
        };
        const left = image.left - host.left;
        const top = image.top - host.top;
        this.mapping = {
          left: left + position(tokens[0], image.width - iw * sx),
          top: top + position(tokens[1], image.height - ih * sy),
          width: iw * sx,
          height: ih * sy,
          sx, sy
        };
        this.bounds = { left, top, width: image.width, height: image.height };
        const small = !this.hoverQuery.matches;
        this.diameter = Math.min(small ? 144 : 180, image.width * .95, image.height * .95);
        this.dpr = Math.min(window.devicePixelRatio || 1, small ? 1.5 : 2);
        return this.diameter >= 32;
      }

      startDrag(event) {
        if (this.hoverQuery.matches) return;
        if (event.button !== 0 || !event.isPrimary) return;
        event.preventDefault();
        event.stopPropagation();
        const rect = this.getBoundingClientRect();
        this.dragging = { id: event.pointerId, startX: event.clientX, startY: event.clientY, moved: false, dx: event.clientX - rect.left - this.x, dy: event.clientY - rect.top - this.y };
        this.bubble.dataset.dragging = '';
        this.bubble.setPointerCapture(event.pointerId);
      }

      drag(event) {
        const drag = this.dragging;
        if (!drag || drag.id !== event.pointerId || !this.open) return;
        event.preventDefault();
        event.stopPropagation();
        if (Math.hypot(event.clientX - drag.startX, event.clientY - drag.startY) > 8) drag.moved = true;
        const rect = this.getBoundingClientRect();
        this.move(event.clientX - rect.left - drag.dx, event.clientY - rect.top - drag.dy);
      }

      endDrag(event) {
        if (!this.dragging || this.dragging.id !== event.pointerId) return;
        event.stopPropagation();
        const drag = this.dragging;
        const tapped = !drag.moved && Math.hypot(event.clientX - drag.startX, event.clientY - drag.startY) <= 8;
        this.dragging = null;
        delete this.bubble.dataset.dragging;
        if (this.bubble.hasPointerCapture(event.pointerId)) this.bubble.releasePointerCapture(event.pointerId);
        if (tapped) this.deactivate();
      }

      setPosition(x, y) {
        const r = this.diameter / 2;
        const bounds = this.bounds;
        this.x = Math.max(bounds.left + r, Math.min(bounds.left + bounds.width - r, x));
        this.y = Math.max(bounds.top + r, Math.min(bounds.top + bounds.height - r, y));
      }

      move(x, y) {
        if (!this.open) return;
        if (!this.motionFrame && this.motion && performance.now() - this.motion.time > 50) this.motion.time = performance.now() - 1000 / 60;
        this.setPosition(x, y);
        this.queueMotion();
      }

      resetMotion() {
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = 0;
        this.motion = {
          x: this.x, y: this.y, time: performance.now(), vx: 0, vy: 0,
          sx: { value: 1, velocity: 0 }, sy: { value: FLEX.height, velocity: 0 }
        };
      }

      queueMotion() {
        if (this.motionFrame || (!this.open && this.life?.kind !== 'closing')) return;
        this.motionFrame = requestAnimationFrame((time) => this.updateMotion(time));
      }

      updateMotion(time) {
        this.motionFrame = 0;
        if (!this.bubble || (!this.open && this.life?.kind !== 'closing')) return;
        if (this.life?.kind === 'closing') {
          this.life.progress = Math.min(1, (time - this.life.started) / (APPEAR.closeDuration * 1000));
          if (this.life.progress >= 1) { this.dispose(); return; }
          this.draw();
          this.queueMotion();
          return;
        }
        const motion = this.motion;
        const elapsed = Math.max(1 / 1000, (time - motion.time) / 1000);
        const dt = Math.min(elapsed, 0.05);
        const blend = 1 - Math.exp(-dt / FLEX.velocityFilter);
        const limit = this.diameter * 16;
        const vx = Math.max(-limit, Math.min(limit, (this.x - motion.x) / elapsed));
        const vy = Math.max(-limit, Math.min(limit, (this.y - motion.y) / elapsed));
        motion.vx += (vx - motion.vx) * blend;
        motion.vy += (vy - motion.vy) * blend;
        motion.x = this.x;
        motion.y = this.y;
        motion.time = time;
        if (this.motionQuery.matches) {
          this.life = null;
          this.resetMotion();
          this.draw();
          return;
        }
        const speed = Math.hypot(motion.vx, motion.vy);
        const amount = speed < 0.5 ? 0 : FLEX.amount * (1 - Math.exp(-speed / (this.diameter * FLEX.normalization)));
        const horizontal = speed ? (motion.vx / speed) ** 2 : 0;
        const vertical = speed ? (motion.vy / speed) ** 2 : 0;
        springStep(motion.sx, 1 + amount * (0.6 * horizontal - vertical), dt);
        springStep(motion.sy, FLEX.height + amount * (0.95 * vertical - 0.18 * horizontal), dt);
        const moving = speed >= 0.5 || Math.abs(motion.sx.value - 1) > 0.0001 || Math.abs(motion.sy.value - FLEX.height) > 0.0001 || Math.abs(motion.sx.velocity) > 0.002 || Math.abs(motion.sy.velocity) > 0.002;
        if (!moving) {
          motion.sx = { value: 1, velocity: 0 };
          motion.sy = { value: FLEX.height, velocity: 0 };
          motion.vx = motion.vy = 0;
        }
        if (this.life?.kind === 'opening') {
          springStep(this.life.progress, 1, dt, APPEAR.response, APPEAR.damping);
          if ((Math.abs(this.life.progress.value - 1) < 0.001 && Math.abs(this.life.progress.velocity) < 0.01) || time - this.life.started > 700) this.life = null;
        }
        this.draw();
        if (moving || this.life) this.queueMotion();
      }

      presentation() {
        if (this.life?.kind === 'opening') {
          const p = Math.max(0, this.life.progress.value);
          return { scale: APPEAR.startScale + (1 - APPEAR.startScale) * p, lift: (1 - p) * this.diameter * APPEAR.lift, opacity: Math.min(1, p * 1.6) };
        }
        if (this.life?.kind === 'closing') {
          const p = this.life.progress;
          const eased = p * p * (3 - 2 * p);
          const from = this.life.from;
          return { scale: from.scale * (1 - 0.86 * eased), lift: from.lift + (this.diameter * APPEAR.lift - from.lift) * eased, opacity: from.opacity * (1 - p) ** 1.35 };
        }
        return { scale: 1, lift: 0, opacity: 1 };
      }

      draw() {
        if (!this.bubble) return;
        const r = this.diameter / 2;
        const presentation = this.presentation();
        let sx = Math.max(0.01, (this.motion?.sx.value ?? 1) * presentation.scale);
        let sy = Math.max(0.01, (this.motion?.sy.value ?? FLEX.height) * presentation.scale);
        const b = this.bounds;
        const fit = Math.min(1, b.width / (this.diameter * sx), b.height / (this.diameter * sy));
        sx *= fit;
        sy *= fit;
        const cx = Math.max(b.left + r * sx, Math.min(b.left + b.width - r * sx, this.x));
        const cy = Math.max(b.top + r * sy, Math.min(b.top + b.height - r * sy, this.y + presentation.lift));
        this.bubble.style.width = `${this.diameter * sx}px`;
        this.bubble.style.height = `${this.diameter * sy}px`;
        this.bubble.style.opacity = presentation.opacity;
        this.bubble.style.transform = `translate3d(${cx - r * sx}px, ${cy - r * sy}px, 0)`;
        if (this.glState) {
          const { gl, locations } = this.glState;
          gl.uniform2f(locations.center, cx, cy);
          gl.uniform2f(locations.shapeScale, sx, sy);
          gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        } else {
          const map = this.mapping;
          const context = this.context;
          context.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
          context.clearRect(0, 0, this.diameter, this.diameter);
          context.setTransform(this.dpr / sx, 0, 0, this.dpr / sy, 0, 0);
          context.drawImage(this.image, r * sx + (map.left - cx) * ZOOM, r * sy + (map.top - cy) * ZOOM, map.width * ZOOM, map.height * ZOOM);
        }
      }

      enhance() {
        if (!this.open) return;
        const canvas = document.createElement('canvas');
        canvas.className = 'laydown-product-lens__glass';
        canvas.width = canvas.height = this.plain.width;
        const gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, depth: false, stencil: false, failIfMajorPerformanceCaveat: true, powerPreference: 'low-power' });
        if (!gl) return;
        const state = { gl, canvas, shaders: [], locations: {} };
        this.glState = state;
        try {
          const compile = (type, source) => {
            const shader = gl.createShader(type);
            state.shaders.push(shader);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            return shader;
          };
          state.program = gl.createProgram();
          gl.attachShader(state.program, compile(gl.VERTEX_SHADER, VERTEX));
          gl.attachShader(state.program, compile(gl.FRAGMENT_SHADER, FRAGMENT));
          gl.linkProgram(state.program);
          if (!gl.getProgramParameter(state.program, gl.LINK_STATUS)) throw new Error('Lens shader unavailable');
          gl.useProgram(state.program);
          state.buffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, state.buffer);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
          const attribute = gl.getAttribLocation(state.program, 'pos');
          gl.enableVertexAttribArray(attribute);
          gl.vertexAttribPointer(attribute, 2, gl.FLOAT, false, 0, 0);
          state.texture = gl.createTexture();
          gl.bindTexture(gl.TEXTURE_2D, state.texture);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
          const limit = Math.min(2048, gl.getParameter(gl.MAX_TEXTURE_SIZE));
          let source = this.image;
          if (Math.max(source.naturalWidth, source.naturalHeight) > limit) {
            const resized = document.createElement('canvas');
            const ratio = limit / Math.max(source.naturalWidth, source.naturalHeight);
            resized.width = Math.round(source.naturalWidth * ratio);
            resized.height = Math.round(source.naturalHeight * ratio);
            resized.getContext('2d').drawImage(source, 0, 0, resized.width, resized.height);
            source = resized;
          }
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
          if (gl.getError() !== gl.NO_ERROR || gl.isContextLost()) throw new Error('Lens texture unavailable');
          for (const name of ['photo', 'imageSize', 'imageOffset', 'center', 'diameter', 'shapeScale']) state.locations[name] = gl.getUniformLocation(state.program, name);
          gl.uniform1i(state.locations.photo, 0);
          gl.uniform2f(state.locations.imageSize, this.mapping.width, this.mapping.height);
          gl.uniform2f(state.locations.imageOffset, this.mapping.left, this.mapping.top);
          gl.uniform1f(state.locations.diameter, this.diameter);
          gl.viewport(0, 0, canvas.width, canvas.height);
          canvas.addEventListener('webglcontextlost', () => {
            if (!this.open) return;
            this.releaseGL();
            this.bubble.dataset.renderer = 'canvas2d';
            this.draw();
          }, { signal: this.activeController.signal });
          this.bubble.append(canvas);
          this.draw();
          this.bubble.dataset.renderer = 'webgl';
        } catch {
          this.releaseGL();
          if (this.open) this.draw();
        }
      }

      deactivate(immediate = false) {
        if (!this.open && !immediate) return;
        this.open = false;
        if (LaydownProductLens.active === this) LaydownProductLens.active = null;
        this.activeController?.abort();
        this.sourceObserver?.disconnect();
        clearTimeout(this.enhanceTimer);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = 0;
        this.dragging = null;
        this.toggle?.setAttribute('aria-pressed', 'false');
        if (this.status) this.status.textContent = '';
        if (!this.bubble) return;
        delete this.bubble.dataset.visible;
        if (immediate || this.motionQuery.matches) this.dispose();
        else {
          const from = this.presentation();
          this.life = { kind: 'closing', started: performance.now(), progress: 0, from };
          this.queueMotion();
        }
      }

      releaseGL() {
        const state = this.glState;
        this.glState = null;
        if (!state) return;
        const { gl } = state;
        if (!gl.isContextLost()) {
          if (state.texture) gl.deleteTexture(state.texture);
          if (state.buffer) gl.deleteBuffer(state.buffer);
          if (state.program) gl.deleteProgram(state.program);
          state.shaders.forEach((shader) => gl.deleteShader(shader));
          gl.getExtension('WEBGL_lose_context')?.loseContext();
        }
        state.canvas.remove();
      }

      dispose() {
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = 0;
        this.life = null;
        this.releaseGL();
        this.bubble?.remove();
        this.bubble = null;
        this.plain = null;
        this.context = null;
      }
    }

    customElements.define('laydown-product-lens', LaydownProductLens);
  })();
  } catch(e) { console.error(e); }
})();

})();
